import { theme } from '@kijiji/theme'

import { Flex } from '@/ui/atoms/flex'
import { Skeleton } from '@/ui/atoms/skeleton'

export const QuickFiltersLoading = () => (
  <Flex gap={theme.spacing.defaultSmall} data-testid="skeleton-quick-filters">
    <Skeleton count={5} height="4rem" width="12rem" isInline bottom="0" />
  </Flex>
)
